export default [{
    path: '/validacao-baixas',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Validação de Baixas Histórico',
        path: 'historico',
        component: () => import('@/views/validacaoBaixas/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups'},
            { name: 'Validação de Baixas' }
          ]
        },
      },
      {
        name: 'Validação de Baixas Adicionar',
        path: 'edit',
        component: () => import('@/views/validacaoBaixas/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups'},
            { name: 'Validação de Baixas', path: '/validacao-baixas/historico' },
            { name: 'Adicionar' }
          ]
        },
      }
    ]
  }]